import { render, staticRenderFns } from "./bonusPointsReport.vue?vue&type=template&id=622f0cd8&"
import script from "./bonusPointsReport.vue?vue&type=script&lang=js&"
export * from "./bonusPointsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports